var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.handleResize,
          expression: "handleResize",
        },
      ],
      staticClass: "pivot-table-widget",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.setSelected($event)
        },
      },
    },
    [
      _vm.tableColumn.length > 0
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              staticClass: "table-box",
            },
            [
              _c(
                "el-table",
                {
                  staticClass: "tableAuto",
                  staticStyle: { width: "100%" },
                  attrs: {
                    size: "small",
                    data: _vm.tableData,
                    border: true,
                    "max-height": _vm.maxHeight,
                    "show-summary":
                      _vm.cutField.options &&
                      _vm.cutField.options.setChartConf.showSummary,
                    "summary-method": _vm.getSummaries,
                  },
                },
                _vm._l(_vm.tableColumn, function (column, inx) {
                  return _c("el-table-column", {
                    key: inx,
                    attrs: {
                      "show-overflow-tooltip": "",
                      label: column.alias,
                      prop: column.fieldName,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "yichu" }, [
                                _vm._v(_vm._s(column.alias)),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("FormatRow", {
                                attrs: { row: scope.row, column: column },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
                1
              ),
            ],
            1
          )
        : _c("div", { staticClass: "no-data" }, [
            _vm._v("\n    请通过右侧\n    "),
            _c("span", { staticClass: "lh" }, [_vm._v("显示字段设置")]),
            _vm._v(" 字段栏来添加数据\n  "),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }